import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
    providedIn: 'root'
})
export class PwaInstallService {
    private deferredPrompt: any = null;
    private _canInstall = new BehaviorSubject<boolean>(false);
    canInstall$ = this._canInstall.asObservable();

    constructor() {
        window.addEventListener('beforeinstallprompt', (event: Event) => {
            event.preventDefault();
            this.deferredPrompt = event;

            // Only show on mobile
            if (this.isMobile()) {
                this._canInstall.next(true);
            }
        });

        // Hide banner if app is already installed
        window.addEventListener('appinstalled', () => {
            this._canInstall.next(false);
            this.deferredPrompt = null;
        });
    }

    private isMobile(): boolean {
        return /Android|iPhone|iPad|iPod|Opera Mini|IEMobile|WPDesktop/i.test(navigator.userAgent);
    }

    async promptInstall(): Promise<void> {
        if (!this.deferredPrompt) return;

        this.deferredPrompt.prompt();
        const { outcome } = await this.deferredPrompt.userChoice;

        if (outcome === 'accepted') {
            this._canInstall.next(false);
        }

        this.deferredPrompt = null;
    }

    dismissBanner(): void {
        this._canInstall.next(false);
        // Suppress for 7 days
        localStorage.setItem('pwa-banner-dismissed', String(Date.now()));
    }

    isBannerSuppressed(): boolean {
        const dismissed = localStorage.getItem('pwa-banner-dismissed');
        if (!dismissed) return false;
        const sevenDays = 7 * 24 * 60 * 60 * 1000;
        return Date.now() - Number(dismissed) < sevenDays;
    }
}